// 模拟API服务
// 在实际项目中，这里会连接到真实的后端API

export interface DramaScript {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: number;
  genre: string;
  tags: string[];
  script: {
    scenes: Scene[];
  };
  createdAt: string;
  views: number;
  likes: number;
}

export interface Scene {
  id: string;
  title: string;
  duration: number;
  setting: string;
  dialogue: Dialogue[];
}

export interface Dialogue {
  character: string;
  text: string;
  emotion: string;
  choices?: Choice[];
}

export interface Choice {
  id: string;
  text: string;
  nextScene?: string;
  consequence: string;
}

// Mock数据
const mockDramas: DramaScript[] = [
  {
    id: '1',
    title: '时间胶囊',
    description: '一个关于时间旅行者试图改变历史的故事',
    thumbnail: '/api/placeholder/800/450',
    duration: 180,
    genre: '科幻',
    tags: ['时间旅行', '爱情', '悬疑'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '发现时间胶囊',
          duration: 60,
          setting: '古老的阁楼，尘土飞扬',
          dialogue: [
            {
              character: '艾米',
              text: '这是什么？一个看起来很古老的盒子...',
              emotion: '好奇'
            },
            {
              character: '爷爷的声音',
              text: '孩子，有些秘密，一旦揭开就无法回头...',
              emotion: '神秘'
            }
          ]
        },
        {
          id: 'scene2',
          title: '第一次穿越',
          duration: 60,
          setting: '1980年代的街道',
          dialogue: [
            {
              character: '艾米',
              text: '天啊，我真的回到了过去！',
              emotion: '震惊'
            },
            {
              character: '年轻时的爷爷',
              text: '小姐，你看起来很困惑，需要帮助吗？',
              emotion: '关切'
            }
          ]
        },
        {
          id: 'scene3',
          title: '关键选择',
          duration: 60,
          setting: '时间胶囊前',
          dialogue: [
            {
              character: '艾米',
              text: '我该如何选择？',
              emotion: '纠结',
              choices: [
                {
                  id: 'choice1',
                  text: '打开时间胶囊，改变历史',
                  consequence: '历史被改变，但一切都变得不一样了'
                },
                {
                  id: 'choice2',
                  text: '保持现状，让历史自然发展',
                  consequence: '回到原本的时间线，但带回了珍贵的回忆'
                }
              ]
            }
          ]
        }
      ]
    },
    createdAt: '2025-10-01',
    views: 12580,
    likes: 892
  },
  {
    id: '2',
    title: '咖啡馆的邂逅',
    description: '都市爱情故事，关于缘分和选择',
    thumbnail: '/api/placeholder/800/450',
    duration: 150,
    genre: '爱情',
    tags: ['都市', '爱情', '缘分'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '初次相遇',
          duration: 50,
          setting: '温馨的咖啡馆',
          dialogue: [
            {
              character: '小雅',
              text: '不好意思，这是你的座位吗？',
              emotion: '害羞'
            },
            {
              character: '李明',
              text: '没关系，我也可以坐对面。',
              emotion: '微笑'
            }
          ]
        },
        {
          id: 'scene2',
          title: '深入了解',
          duration: 50,
          setting: '咖啡馆内',
          dialogue: [
            {
              character: '小雅',
              text: '你也喜欢喝咖啡吗？',
              emotion: '好奇'
            },
            {
              character: '李明',
              text: '是的，这里的拿铁很不错。你呢？',
              emotion: '友善'
            }
          ]
        },
        {
          id: 'scene3',
          title: '告别时刻',
          duration: 50,
          setting: '咖啡馆门口',
          dialogue: [
            {
              character: '小雅',
              text: '今天很开心认识你！',
              emotion: '开心',
              choices: [
                {
                  id: 'choice1',
                  text: '主动索要联系方式',
                  consequence: '两人交换了联系方式，故事继续发展'
                },
                {
                  id: 'choice2',
                  text: '含蓄告别，期待下次相遇',
                  consequence: '留下了美好的回忆，但不知何时能再见'
                }
              ]
            }
          ]
        }
      ]
    },
    createdAt: '2025-10-02',
    views: 8920,
    likes: 756
  },
  {
    id: '3',
    title: '古风探案',
    description: '古代探案故事，需要观众协助破案',
    thumbnail: '/api/placeholder/800/450',
    duration: 200,
    genre: '悬疑',
    tags: ['古代', '探案', '推理'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '案件发生',
          duration: 66,
          setting: '古代客栈',
          dialogue: [
            {
              character: '老板',
              text: '官爷，昨晚有人偷了我的传家宝！',
              emotion: '焦急'
            },
            {
              character: '县令',
              text: '不要慌张，本官一定会查个水落石出。',
              emotion: '严肃'
            }
          ]
        },
        {
          id: 'scene2',
          title: '寻找线索',
          duration: 67,
          setting: '案发现场',
          dialogue: [
            {
              character: '县令',
              text: '这里似乎有什么奇怪的痕迹...',
              emotion: '思考'
            },
            {
              character: '衙役',
              text: '大人，我们发现了一枚奇怪的玉佩。',
              emotion: '恭敬'
            }
          ]
        },
        {
          id: 'scene3',
          title: '真相大白',
          duration: 67,
          setting: '公堂之上',
          dialogue: [
            {
              character: '县令',
              text: '根据所有线索，我已经知道凶手是谁了！',
              emotion: '自信',
              choices: [
                {
                  id: 'choice1',
                  text: '指认老板自己监守自盗',
                  consequence: '老板承认是为了骗取保险而自导自演'
                },
                {
                  id: 'choice2',
                  text: '指认竞争对手所为',
                  consequence: '竞争对手承认是为了打击生意而偷窃'
                }
              ]
            }
          ]
        }
      ]
    },
    createdAt: '2025-10-03',
    views: 5670,
    likes: 445
  }
];

// API函数
export const dramaApi = {
  // 获取所有短剧
  getAllDramas: async (): Promise<DramaScript[]> => {
    // 模拟网络延迟
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockDramas;
  },

  // 根据ID获取短剧
  getDramaById: async (id: string): Promise<DramaScript | null> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return mockDramas.find(drama => drama.id === id) || null;
  },

  // 根据类型获取短剧
  getDramasByGenre: async (genre: string): Promise<DramaScript[]> => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return mockDramas.filter(drama => drama.genre === genre);
  },

  // 搜索短剧
  searchDramas: async (query: string): Promise<DramaScript[]> => {
    await new Promise(resolve => setTimeout(resolve, 600));
    const lowerQuery = query.toLowerCase();
    return mockDramas.filter(drama =>
      drama.title.toLowerCase().includes(lowerQuery) ||
      drama.description.toLowerCase().includes(lowerQuery) ||
      drama.tags.some(tag => tag.toLowerCase().includes(lowerQuery))
    );
  },

  // 获取热门短剧
  getPopularDramas: async (limit: number = 6): Promise<DramaScript[]> => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return mockDramas
      .sort((a, b) => b.views - a.views)
      .slice(0, limit);
  },

  // 更新观看次数
  updateViews: async (id: string): Promise<void> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const drama = mockDramas.find(d => d.id === id);
    if (drama) {
      drama.views += 1;
    }
  },

  // 更新点赞数
  updateLikes: async (id: string, increment: boolean): Promise<void> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const drama = mockDramas.find(d => d.id === id);
    if (drama) {
      drama.likes += increment ? 1 : -1;
    }
  }
};

export default dramaApi;